import { DatalayerHelper } from './ib-datalayer-helper';
import * as ancillariesInfo   from '../core/models/ancillaries-info';


@Service('ib-web-ancillaries-module',
    ['CommonsUtilService', 'DatalayerUtilsService', 'DatalayerHelper', 'localStorageService'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class InsuranceDatalayerUtils {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CommonsUtilService: CommonsUtilService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerHelper: DatalayerHelper
    ) { }

    getInsuranceItemVariant = (offer) => offer?.code.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    getDataEcommerceForInsurance (ancillaryType, anc, offer) {
        const confirmationDatalayerInfo: any = this.localStorageService.get('confirmationDatalayerInfo');
        const id = this.CommonsUtilService.getIdItem('all');
        const all = 'all';
        const item: DigitalDataEcommerceModel.Item = {
            item_name: ancillaryType,
            item_id: id,
            price: offer.premium,
            item_brand: anc?.provider.toLowerCase(),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: all,
            item_category3: all,
            item_variant: this.getInsuranceItemVariant(offer),
            quantity: confirmationDatalayerInfo?.numeroPax
        };
        return item;
    }
}

